export default {
      id: "icon-calendar-usage",
      viewBox: "0 0 16 16",
      url: "/" + "assets/sprite.svg#icon-calendar",
      toString: function () {
        return this.url;
      }
    }